import axios from "axios";

const schedule_service_api = axios.create({
  baseURL: process.env.REACT_APP_SCHEDULE_SERVICE_BASE_URL
});

export default schedule_service_api;
